"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhysicsUpdate = void 0;
var rxjs_1 = require("rxjs");
var FPS = 60;
var PhysicsUpdate = function () {
    var frameLength = 1000 / FPS;
    var lastTimestamp = 0;
    var isRunning = false;
    var updateSubject = new rxjs_1.Subject();
    var updateSubscription = null;
    var start = function () {
        if (isRunning)
            return;
        isRunning = true;
        lastTimestamp = performance.now();
        updateSubscription = (0, rxjs_1.interval)(frameLength).pipe((0, rxjs_1.map)(function () {
            var now = performance.now();
            var deltaTime = (now - lastTimestamp) / frameLength;
            lastTimestamp = now;
            return deltaTime;
        })).subscribe(function (deltaTime) {
            updateSubject.next(deltaTime);
        });
    };
    var pause = function () {
        if (!isRunning)
            return;
        isRunning = false;
        if (updateSubscription) {
            updateSubscription.unsubscribe();
            updateSubscription = null;
        }
    };
    var stop = function () {
        pause();
        updateSubject.complete();
    };
    var subscribe = function (callback) {
        return updateSubject.subscribe(callback);
    };
    return {
        start: start,
        pause: pause,
        stop: stop,
        subscribe: subscribe,
    };
};
exports.PhysicsUpdate = PhysicsUpdate;
